/**
 * @(#)2019/11/26.
 * WidgetConfig，配置组件，用于控制组件配置
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import { BaseConfig } from "../../config";
import { Language } from "../../config/language";
import { get, merge, createScriptFormRemote } from "../../utils";

class WidgetConfig {
  static set(config) {
    if ("iconFontUrls" in config) {
      createScriptFormRemote(config.iconFontUrls);
    }
    BaseConfig.config = merge(BaseConfig.config, config);
  }

  /**
   * 覆盖语言包
   *
   * @static
   * @param {*} config
   * @memberof WidgetConfig
   */
  static setLanguage(config) {
    Language.config = merge(Language.config, config);
  }
}

export default WidgetConfig;



// WEBPACK FOOTER //
// ./src/yx-widget/component/WidgetConfig/index.js